import React, { useEffect, useState } from "react";
import "../../Assets/Css/AddUpdateShareHolder.scss";
import SidebarLayout from "../../Layouts/Sidebarlayout";
import { customStyle } from "../../Components/Style";
import Select from "react-select";
import showEye from "../../Assets/Images/Login-Page/showeye.png";
import hideEye from "../../Assets/Images/Login-Page/hideeye.png";
import { useNavigate, useLocation } from "react-router-dom";
import { Spinner } from 'react-bootstrap';
import {
  addShareholder,
  getAllRoles,
  getShareholders,
  updateShareholder
} from "../../Services/Shareholders/action";
import { getClients } from "../../Services/Clients/action";
import { getAllTransactions } from "../../Services/Transactions/action";
import { FaTrashAlt } from "react-icons/fa";
import { FiArrowDownLeft, FiArrowUpLeft } from "react-icons/fi";
import { useRef } from "react";
import { useFormik } from "formik";
import { addShareholderValidation } from "../../Validations/addShareholderValidation";
import { updateShareholderValidation } from "../../Validations/updateShareholderValidation";
import { connect } from "react-redux";
import { toast } from "react-toastify";

const AddUpdateShareHolder = (props) => {
  const [show, setShow] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [finalData, setFinalData] = useState({
    id: "",
    name: "",
    email: "",
    mobile: "",
    password: "",
    newPassword: ""
  });
  const [roleData, setRoleData] = useState([]);
  const [clientsData, setClietsData] = useState([]);
  const [deletedItem, setDeletedItem] = useState({
    clients: [],
    transaction: [],
  });
  const [shRole, setShRole] = useState({ value: "", label: "" });
  const [shClients, setShClients] = useState([]);
  const [shTransactions, setShTransactions] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [shareholderData, setShareholderData] = useState([]);
  const [optionType, setOptionType] = useState([]);
  let [optionTypeClients, setOptionTypeClients] = useState([]);
  let [optionTypeTransactions, setOptionTypeTransactions] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const shareholderId = location?.state?.data?.shId;

  const getSetAllTrans = async () => {
    try {
      await props.getAllTransactions();
    } catch (error) {
      toast.error(error);
    }
  }
  const getTransOption = () => {
    return props.transactionList?.map((trans) => {
      let usedBalance = 0;
      trans.transactionShareHolderMap.forEach(val => {
        usedBalance += parseFloat(val.amount);
      })
      trans.availableBalance = usedBalance == 0 ? trans.amount : trans.amount - usedBalance;
      return {
        value: trans,
        label: (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              width: "100%",
              margin: 0,
              padding: 0,
            }}
          >
            <div style={{
              display: "flex",
              flexWrap: "wrap"
            }}>
              <span style={{ marginRight: "10px" }}>{trans.id}</span>
              {trans.type.toLowerCase() === "credit" ? (
                <span style={{ marginRight: "10px" }} className="credit-icon">
                  <FiArrowUpLeft />
                </span>
              ) : (
                <span style={{ marginRight: "10px" }} className="debit-icon">
                  <FiArrowDownLeft />
                </span>
              )}
              <span style={{ marginRight: "15px" }}>₹{trans.amount}</span>
              <span style={{ marginRight: "10px", whiteSpace: "nowrap" }}>{trans.updated_at}</span>
            </div>
            <div>
              <span style={{ marginRight: "10px" }}>Available : ₹{trans.availableBalance}</span>
            </div>
          </div>
        ),
      };
    })
  }

  useEffect(() => {
    const options = getTransOption();
    if (isUpdate) {
      let transactionsId = shareholderData?.shareHolderTransactionMap?.map(item => item.transaction_id);
      let transactions = options?.filter(item => transactionsId?.includes(item.value.id));
      transactions = transactions?.map((item) => {
        const amountData = shareholderData?.shareHolderTransactionMap?.find(val => val.transaction_id === item.value.id);
        return {
          ...item,
          value: {
            ...item.value,
            newTrans: amountData.amount
          }
        }
      })
      setShTransactions(transactions);
      setOptionTypeTransactions(options?.filter(item => !transactionsId?.includes(item.value.id)));
    } else {
      setOptionTypeTransactions(options);
    }
  }, [props.transactionList])
  useEffect(() => {
    const clientsOptions = props.clientList?.map((client) => {
      return {
        value: client,
        label: client.name,
      };
    })
    if (isUpdate) {
      let client = shareholderData?.managedBy?.map((item) => {
        return { value: item, label: item.name };
      });
      setShClients(client);
      let clinetsId = client?.map(item => item.value.id);
      setOptionTypeClients(clientsOptions?.filter(item => !clinetsId?.includes(item.value.id)))
    } else {
      setOptionTypeClients(clientsOptions);
    }
  }, [props.clientList])
  useEffect(() => {
    setOptionType(props.shareHolderDetails?.roles?.map((role) => {
      return {
        value: role,
        label: role.name,
      };
    }))
  }, [props.shareHolderDetails])

  const fetchAllData = async () => {
    try {
      if (!(props.shareHolderDetails?.shareholders?.rows?.length > 0)) await props.getShareholders();
      if (!(props.shareHolderDetails?.roles?.length > 0)) await props.getAllRoles();
      if (shareholderId !== undefined) {
        setIsUpdate(true);
        setShareholderData(props?.shareHolderDetails?.shareholders?.rows?.find(
          (item) => item.id === shareholderId
        ));
      }
      await props.getClients();
      getSetAllTrans();
    } catch (error) {
      toast.error(error);
    }
  }

  useEffect(() => {
    if (isUpdate && !shareholderId) {
      toast.error("Something went wrong");
      navigate("/shareholder");
    } else {
      fetchAllData();
    }
  }, []);

  useEffect(() => {
    if (isUpdate) {
      if (!shareholderId) {
        toast.error("Something went wrong");
        navigate("/shareholder");
      } else {
        setFinalData({
          id: shareholderData?.id,
          name: shareholderData?.name,
          email: shareholderData?.email,
          mobile: shareholderData?.mobile,
          role_id: shareholderData?.role,
          clients: shareholderData?.managedBy,
          // transaction: shareholderData?.shareHolderTransactionMap,
        });
        values.name = shareholderData?.name;
        values.email = shareholderData?.email;
        values.mobile = shareholderData?.mobile;

        setShRole({
          value: shareholderData?.role,
          label: shareholderData?.role?.name,
        });
      }
    }
  }, [isUpdate]);


  let initalVal = {
    name: "",
    email: "",
    password: "",
    mobile: "",
    newPassword: ""
  };

  // SUBMIT
  const handleOnSubmit = async () => {
    const { password, newPassword, email, mobile, ...dataToBeUpdate } = finalData;

    if (!shRole.value) {
      toast.error("Role is Required");
      return;
    }

    let addTrans = [], updateTrans = [];
    const allSelectedTrans = shTransactions.map(item => item.value);
    const deletedTransId = deletedItem["transaction"].map(item => item.id);
    allSelectedTrans.map(item => {
      const isPresentInDeleted = item.transactionShareHolderMap.some(val => deletedTransId?.includes(val.id));
      if (isPresentInDeleted) {
        addTrans.push({ transaction_id: item.id, amount: parseFloat(item.newTrans) })
      } else {
        const isGoingToUpdate = item.transactionShareHolderMap.find(val => val.shareholder_id === shareholderId);
        // If transaction aleready in list then it going to be update else we will Add
        if (isGoingToUpdate) {
          updateTrans.push({ id: isGoingToUpdate.id, transaction_id: item.id, amount: parseFloat(item.newTrans) })
        } else {
          addTrans.push({ transaction_id: item.id, amount: parseFloat(item.newTrans) })
        }
      }
    })

    // Formatting For Clients
    const deleteClients = deletedItem["clients"].map(item => {
      return {
        id: item.id,
        managed_by: null
      }
    })
    const newClients = clientsData.map((item) => {
      return {
        id: item.id,
        managed_by: shareholderId
      }
    })

    try {
      if (isUpdate) {
        // Updation Logic
        let requestData = {
          ...dataToBeUpdate,
          password: newPassword !== undefined ? newPassword : null,
          role_id: shRole.value.id,
          managedBy: [...newClients, ...deleteClients],
          shareHolderTransactionMap: [...addTrans, ...updateTrans, ...deletedItem["transaction"]],
          role_name: shRole.label
        };
        if (shareholderData.email !== email) requestData.updatedEmail = email;
        else requestData.email = email;
        if (shareholderData.mobile !== mobile) requestData.updatedMobile = mobile
        else requestData.mobile = mobile;
        props.updateShareholder(shareholderId, requestData);
      }
      else {
        // Creation / Add Logic
        let addData = {
          ...dataToBeUpdate,
          email,
          mobile,
          password,
          role_id: roleData.id,
          managed_by: clientsData.map((val) => val.id),
          shareHolderTransactionMap: shTransactions.map((val) => {
            return { transaction_id: val.value.id, amount: val.value.newTrans, type: val.value.type };
          }),
        };
        props.addShareholder(addData);
        values.name = "";
        values.email = "";
        values.password = "";
        values.mobile = "";
        setShClients([]);
        setShTransactions([]);
        setShRole({});
        const options = getTransOption();
        setOptionTypeTransactions(options);
      }
      await props.getShareholders();
      setIsLoading(false);
    } catch (error) {
      console.log("error", error);
    }
  }

  let { values, errors, touched, handleChange, handleSubmit } = useFormik({
    initialValues: initalVal,
    validationSchema: isUpdate === false ? addShareholderValidation : updateShareholderValidation,
    onSubmit: handleOnSubmit
  });

  useEffect(() => {
    setFinalData({ ...values });
  }, [values]);

  // Handles Delete for React Select
  const handleDeleteClinet = (valueToDelete) => {
    if (isUpdate) {
      // Delete list When Update Mode is On
      const isClientDataPresent = shareholderData?.managedBy?.some(item => item.id === valueToDelete.value.id);
      if (isClientDataPresent) {
        let deleteField = { ...valueToDelete.value, deleted_at: new Date() };
        setDeletedItem({
          ...deletedItem,
          clients: [...deletedItem["clients"], deleteField],
        });
      }
      // when delete from List occured then those li element added into options dropdown
      const isDataPresentInOptions = optionTypeClients?.some(item => item.value.id === valueToDelete.value.id);
      if (isDataPresentInOptions === false) {
        optionTypeClients = optionTypeClients || [];
        const data = [...optionTypeClients, valueToDelete];
        const sortedData = data.sort((a, b) => a.value.id - b.value.id);
        setOptionTypeClients(sortedData);
      }
    }
    const filteredValues = shClients.filter((val) => val.value.id !== valueToDelete.value.id);
    setShClients(filteredValues);
    setClietsData(filteredValues.map(fVal => fVal.value));
  };
  const handleDeleteTrans = (valueToDelete) => {
    console.log(valueToDelete, "valueToDelete");
    if (isUpdate) {
      let isDataPresent = shareholderData?.shareHolderTransactionMap?.find(item => item.transaction_id == valueToDelete.value.id);
      if (isDataPresent) {
        let deletes = valueToDelete.value.transactionShareHolderMap.find(item => item.shareholder_id == shareholderId);
        let deleteField = { id: deletes.id, transaction_id: deletes.transaction_id, amount: parseFloat(deletes.amount), deleted_at: new Date() };
        setDeletedItem({
          ...deletedItem,
          transaction: [...deletedItem["transaction"], deleteField],
        });
      }
    }
    const filteredValues = shTransactions?.filter((val) => val.value.id !== valueToDelete.value.id);
    setShTransactions(filteredValues);
    const aleredyPresentTransaction = optionTypeTransactions.some(item => item.value.id === valueToDelete.value.id);
    if (aleredyPresentTransaction === false) {
      optionTypeTransactions = optionTypeTransactions || [];
      valueToDelete.value.newTrans = "";
      const data = [...optionTypeTransactions, valueToDelete];
      let sortedData = data.sort((a, b) => a.value.id - b.value.id);
      setOptionTypeTransactions(sortedData);
    }
  };

  const handleAmountSelect = (e, selectedVal) => {
    if (parseFloat(e.target.value) < 0) return;
    if (isUpdate) {
      const oldVal = shareholderData.shareHolderTransactionMap.find(item => item.transaction_id === selectedVal.value.id);
      if (parseFloat(e.target.value) > ((oldVal ? parseFloat(oldVal.amount) : 0) + parseFloat(selectedVal.value.availableBalance))) {
        toast.error("Excced Transaction Amount , Please Enter Correct Amount");
        return;
      }
    }
    else {
      if (parseFloat(e.target.value) > parseFloat(selectedVal.value.availableBalance)) {
        toast.error("Excced Transaction Amount , Please Enter Correct Amount");
        return;
      }
    }
    let updatedTransactions = shTransactions.map((transaction) => {
      if (transaction.value.id === selectedVal.value.id) {
        return {
          ...transaction,
          value: {
            ...transaction.value,
            newTrans: e.target.value
          },
        };
      }
      return transaction;
    });
    setShTransactions(updatedTransactions);
    setOptionTypeTransactions(optionTypeTransactions?.filter((val) => val.value.id !== selectedVal.value.id));
  }
  return (
    <SidebarLayout>
      <div className="addUpdateShareholder-main">
        <div className="page-title">
          <h4>{isUpdate ? "Update" : "Add"} Share Holder</h4>
          <div className="edit-btn">
            <button className="custom-btn" type="submit" onClick={handleSubmit}>
              {props.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Save'}
            </button>
          </div>
        </div>
        <div className="content-part">
          <div className="row">
            <div className="col-lg-8">
              <div className="left-part">
                <div className="custom-row">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="input-group">
                        <h6 className="label">Name</h6>
                        <input
                          disabled={isLoading}
                          type="text"
                          value={values.name}
                          name="name"
                          onChange={handleChange}
                          className="input-css"
                        />
                        {errors.name && touched.name ? (
                          <p className="error-text">{errors.name}</p>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-group">
                        <h6 className="label">Email</h6>
                        <input
                          disabled={isLoading}
                          type="email"
                          value={values.email}
                          name="email"
                          onChange={handleChange}
                          className="input-css"
                        />
                        {errors.email && touched.email ? (
                          <p className="error-text">{errors.email}</p>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-group">
                        <h6 className="label">Mobile</h6>
                        <input
                          disabled={isLoading}
                          type="text"
                          value={values.mobile}
                          name="mobile"
                          onChange={handleChange}
                          className="input-css"
                        />
                        {errors.mobile && touched.mobile ? (
                          <p className="error-text">{errors.mobile}</p>
                        ) : null}
                      </div>
                    </div>
                    {
                      isUpdate && <div className="col-lg-6">
                        <div className="input-group">
                          <h6 className="label">New Passowrd</h6>
                          <div className="input-with-btn">
                            <input
                              disabled={isLoading}
                              type={show ? "password" : "text"}
                              value={values.newPassword}
                              name="newPassword"
                              onChange={handleChange}
                              className="input-css with-btn"
                            />

                            <label htmlFor="text">
                              <button className="label-btn">
                                <img
                                  src={show ? showEye : hideEye}
                                  alt="password-show"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setShow(!show);
                                  }}
                                />
                              </button>
                            </label>
                          </div>
                          {errors.newPassword && touched.newPassword ? (
                            <p className="error-text">{errors.newPassword}</p>
                          ) : null}
                        </div>
                      </div>
                    }
                    {
                      !isUpdate && <div className="col-lg-6">
                        <div className="input-group">
                          <h6 className="label">Passowrd</h6>
                          <div className="input-with-btn">
                            <input
                              disabled={isLoading}
                              type={show ? "password" : "text"}
                              value={values.password}
                              name="password"
                              onChange={handleChange}
                              className="input-css with-btn"
                            />

                            <label htmlFor="text">
                              <button className="label-btn">
                                <img
                                  src={show ? showEye : hideEye}
                                  alt="password-show"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setShow(!show);
                                  }}
                                />
                              </button>
                            </label>
                          </div>
                          {errors.password && touched.password ? (
                            <p className="error-text">{errors.password}</p>
                          ) : null}

                        </div>
                      </div>
                    }
                    <div className="col-lg-12">
                      <h6 className="label">Transaction</h6>
                      <Select
                        isMulti
                        disabled={isLoading}
                        styles={customStyle}
                        options={optionTypeTransactions || []}
                        value={shTransactions}
                        onChange={(value) => {
                          setShTransactions(value);
                        }}
                        controlShouldRenderValue={false}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#5757fe",
                            primary: "#5757fe",
                          },
                        })}
                      />
                      <ul className="ListMenu">
                        {shTransactions && shTransactions?.map((selectedValue, index) => {
                          return <li key={index}>
                            {selectedValue.label}
                            <div className="second-part-list">
                              <span style={{ whiteSpace: "nowrap" }}>Amount : </span>
                              &nbsp;
                              <input type="number"
                                className="input-css"
                                value={"transaction_id" in selectedValue.value ? selectedValue?.value?.transactionShareHolderMap?.newTrans : selectedValue?.value?.newTrans || ""}
                                placeholder="Amount"
                                style={{
                                  width: "150px"
                                }}
                                onChange={(e) => handleAmountSelect(e, selectedValue)}
                              /> &nbsp;
                              <FaTrashAlt
                                className="deleteIcon"
                                onClick={() => handleDeleteTrans(selectedValue)}
                              />
                            </div>
                          </li>
                        }
                        )}
                      </ul>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="right-part">
                <div className="card-type">
                  <h6 className="label">Role</h6>
                  <Select
                    options={optionType}
                    value={shRole}
                    disabled={isLoading}
                    onChange={(value) => {
                      setShRole(value);
                      setRoleData(value["value"]);
                    }}
                    styles={customStyle}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#5757fe",
                        primary: "#5757fe",
                      },
                    })}
                  />
                </div>
                <div className="card-type full-height">
                  <h6 className="label">Client</h6>
                  <Select
                    isMulti
                    disabled={isLoading}
                    styles={customStyle}
                    options={optionTypeClients || []}
                    value={shClients}
                    onChange={(value) => {
                      setShClients(value);
                      setClietsData(value.map((val) => val.value));
                    }}
                    controlShouldRenderValue={false}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#5757fe",
                        primary: "#5757fe",
                      },
                    })}
                  />
                  {shClients && (
                    <ul className="ListMenu">
                      {shClients?.map((selectedValue) => (
                        <li key={selectedValue.value.id}>
                          {selectedValue.label}
                          <FaTrashAlt
                            className="deleteIcon"
                            onClick={() =>
                              handleDeleteClinet(selectedValue)
                            }
                          />
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                <div></div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </SidebarLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.shareholdersReducer.loading,
    clientList: state.clientsReducer.clients.rows,
    transactionList: state.transactionReducers.transactions.rows,
    shareHolderDetails: state.shareholdersReducer,
    success: state.shareholdersReducer.success
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getClients: () => {
      dispatch(getClients(""));
    },
    getAllTransactions: () => {
      dispatch(getAllTransactions());
    },
    getShareholders: () => {
      dispatch(getShareholders());
    },
    getAllRoles: () => {
      dispatch(getAllRoles());
    },
    addShareholder: (postData) => {
      dispatch(addShareholder(postData));
    },
    updateShareholder: (id, postData) => {
      dispatch(updateShareholder(id, postData))
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(AddUpdateShareHolder);
